(function () {
  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  // This snippet's <script src> tag is rendered once per video block, so
  // this file can execute several times on one page (carousels, sliders).
  // Guard the one-time document-level listener registration below so
  // re-execution doesn't stack up duplicate "shopify:section:load"
  // listeners - init() itself is already idempotent per-button.
  if (window.__videoAutoplayToggleListenerAdded) return;
  window.__videoAutoplayToggleListenerAdded = true;

  function setState(button, pauseIcon, playIcon, isPlaying) {
    button.setAttribute("aria-pressed", String(isPlaying));
    button.setAttribute(
      "aria-label",
      isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel
    );
    pauseIcon.hidden = !isPlaying;
    playIcon.hidden = isPlaying;
  }

  function init(button) {
    if (button.dataset.videoAutoplayToggleReady) return;
    button.dataset.videoAutoplayToggleReady = "true";

    var video = document.getElementById(button.dataset.controls);
    if (!video) return;

    var pauseIcon = button.querySelector(".video-autoplay-toggle__icon--pause");
    var playIcon = button.querySelector(".video-autoplay-toggle__icon--play");

    button.addEventListener("click", function () {
      if (video.paused) {
        video.dataset.userPaused = "false";
        video.play();
      } else {
        video.dataset.userPaused = "true";
        video.pause();
      }
    });

    video.addEventListener("play", function () {
      setState(button, pauseIcon, playIcon, true);
    });
    video.addEventListener("pause", function () {
      setState(button, pauseIcon, playIcon, false);
    });

    if (prefersReducedMotion) {
      video.dataset.userPaused = "true";
      video.pause();
    }

    setState(button, pauseIcon, playIcon, !video.paused);
  }

  function initAll(root) {
    root.querySelectorAll("[data-video-autoplay-toggle]").forEach(init);
  }

  initAll(document);
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
